import { Formik, FormikProps } from 'formik'
import * as React from 'react'
import { Redirect, RouteComponentProps } from 'react-router'
import * as Yup from 'yup'
import { isTokenValid } from '../../utils/auth'
import Logo from '../icons/ui/Logo'
import RecoveryPasswordForm from '../../containers/auth/RecoveryPasswordForm'

interface IRecoveryPasswordProps extends RouteComponentProps<void> {
  isFetching: boolean
  isFetchSuccess: boolean
  isLogged: boolean
  resetFetchSuccess: () => void
  submit: (data: { [key: string]: string }) => void
}

const RecoveryPassword = (props: IRecoveryPasswordProps) => {
  React.useEffect(() => {
    return () => {
      props.resetFetchSuccess()
    }
  }, [])

  const RecoveryPasswordFormWrap = (formikProps: FormikProps<{ emailOrUsername: string }>) => (
    <RecoveryPasswordForm {...formikProps} isFetching={props.isFetching} isFetchSuccess={props.isFetchSuccess} />
  )

  if (props.isLogged || isTokenValid()) {
    return <Redirect to={`/trips`} />
  }
  return (
    <div className='bg-green flex items-center justify-center' style={{ minHeight: '100vh' }}>
      <div className='bg-white b-rad-10 my3 pb3 pt4 px3'>
        <Logo className='block b-rad-6 icon--90x90 margin-auto' />
        <Formik
          initialValues={{ emailOrUsername: '' }}
          validationSchema={Yup.object().shape({
            emailOrUsername: Yup.string().required('Username or email is required')
          })}
          onSubmit={props.submit}
          render={RecoveryPasswordFormWrap}
        />
      </div>
    </div>
  )
}

export default RecoveryPassword



// WEBPACK FOOTER //
// ./src/components/authentication/RecoveryPassword.tsx